import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsWidthHeightMidia } from 'src/app/shared/components/card-midia/card-midia-constants';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { StatusBadgeTipo } from 'src/app/shared/components/status-badge/status-badge.component';
import { IGrupoLicenca } from '../grupo-testes/grupo-testes.component';

@Component({
    selector: 'card-comparativo',
    templateUrl: './card-comparativo.component.html',
    styleUrls: ['./card-comparativo.component.scss']
})
export class CardComparativoComponent implements OnInit {
    constantsWidthHeightMidia = ConstantsWidthHeightMidia;

    @Input() grupo!: IGrupoLicenca;

    disponivel = false;

    constructor(private router: Router) {}

    ngOnInit(): void {
        this.setarDisponibilidade();
    }

    private setarDisponibilidade(){
        this.disponivel = this.grupo.licencasMateriais.every(
            licencaMaterial => licencaMaterial.licenca.data_fim != null
        );
    }

    get nomesTestes(): string {
        return this.grupo.licencasMateriais
            .map(licencaMaterial => licencaMaterial.licenca.teste.nome)
            .join(', ');
    }

    get total(): number {
        return this.grupo.licencasMateriais.length;
    }

    get concluidas(): number {
        return this.grupo.licencasMateriais.filter(
            licencaMaterial => licencaMaterial.licenca.data_fim != null
        ).length;
    }

    get badge(): { tipo: StatusBadgeTipo; label: string; detalhe?: string } {
        if (this.disponivel) {
            return { tipo: 'concluido', label: 'Pronto para ver' };
        }
        if (this.concluidas > 0) {
            return { tipo: 'em_andamento', label: 'Em andamento', detalhe: `${this.concluidas} de ${this.total}` };
        }
        return { tipo: 'bloqueado', label: 'Bloqueado' };
    }

    tooltipCadeado() {
        return `Disponível após concluir todos os ${this.total} testes`;
    }

    iniciar() {
        const idLicenca = this.grupo.licencasMateriais[0].licenca.uuid;
        this.router.navigate([
            ConstantsRotasDoSistema.DEFAULT_PATH + ConstantsRotasDoSistema.COMPARACAO_RELATORIOS + '/' + idLicenca
        ]);
    }
}
